import { createSlice } from "@reduxjs/toolkit";
import { getAddConsumableList, editConsumable, deleteConsumable, getAllGroups, createConsumable, createGroup } from "./AddConsumableThunk";

const initialState = {
  addConsumableListSuccess: null,
  addConsumableListErr: null,
  editConsumableSuccess: null,
  editConsumableErr: null,
  deleteConsumableSuccess: null,
  deleteConsumableErr: null,
  getAllGroupSuccess: null,
  getAllGroupErr: null,
  createConsumableSuccess: null,
  createConsumableErr: null,
  createGroupSuccess: null,
  createGroupErr: null,
};

const addConsumableSlice = createSlice({
  name: "addConsumableSlice",
  initialState,
  reducers: {
    resetGetAddConsumableList(state) {
      state.addConsumableListSuccess = null;
      state.addConsumableListErr = null;
    },
    resetEditConsumable(state) {
      state.editConsumableErr = null;
      state.editConsumableSuccess = null;
    },
    resetDeleteConsumable(state) {
      state.deleteConsumableErr = null;
      state.deleteConsumableSuccess = null;
    },
    resetGetAllGroups(state) {
      state.getAllGroupErr = null;
      state.getAllGroupSuccess = null;
    },
    resetCreateConsumable(state) {
      state.createConsumableSuccess = null;
      state.createConsumableErr = null;
    },
    resetCreateGroup(state) {
      state.createGroupSuccess = null;
      state.createGroupErr = null;
    },
  },
  extraReducers: (builder) => {
    builder
      //  GET LIST OF ADDITIONAL CONSUMABLE
      .addCase(getAddConsumableList.fulfilled, (state, action) => {
        state.addConsumableListSuccess = action.payload;
      })
      .addCase(getAddConsumableList.rejected, (state, action) => {
        state.addConsumableListErr = action.error.message;
      })
      //  UPDATE ADDITIONAL CONSUMABLE
      .addCase(editConsumable.fulfilled, (state, action) => {
        state.editConsumableSuccess = action.payload;
      })
      .addCase(editConsumable.rejected, (state, action) => {
        state.editConsumableErr = action.error.message;
      })
      //  DELETE ADDITIONAL CONSUMABLE
      .addCase(deleteConsumable.fulfilled, (state, action) => {
        state.deleteConsumableSuccess = action.payload;
      })
      .addCase(deleteConsumable.rejected, (state, action) => {
        state.deleteConsumableErr = action.error.message;
      })
      //  DELETE ADDITIONAL CONSUMABLE
      .addCase(getAllGroups.fulfilled, (state, action) => {
        state.getAllGroupSuccess = action.payload;
      })
      .addCase(getAllGroups.rejected, (state, action) => {
        state.getAllGroupErr = action.error.message;
      })
      //  CREATE ADDITIONAL CONSUMABLE
      .addCase(createConsumable.fulfilled, (state, action) => {
        state.createConsumableSuccess = action.payload;
      })
      .addCase(createConsumable.rejected, (state, action) => {
        state.createConsumableErr = action.error.message;
      })
      //  CREATE CONSUMABLES GROUPS
      .addCase(createGroup.fulfilled, (state, action) => {
        state.createGroupSuccess = action.payload;
      })
      .addCase(createGroup.rejected, (state, action) => {
        state.createGroupErr = action.error.message;
      });
  },
});
export const { resetGetAddConsumableList, resetEditConsumable, resetDeleteConsumable, resetGetAllGroups, resetCreateConsumable, resetCreateGroup } = addConsumableSlice.actions;
export default addConsumableSlice.reducer;
